import React, { Component } from 'react'
import Page from 'components/Page'
import JoinAccount from 'features/Auth/JoinAccount'
import sLay from 'styles/modules/layout.scss'

export default class JoinAccountPage extends Component {
  render() {
    return (
      <Page title="Join" className={sLay['layout-column']}>
        <JoinAccount />
      </Page>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/JoinAccount/JoinAccount.jsx